import api from './api';

export const getUserLogs = (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.user_id) queryParams.append('user_id', params.user_id);
    if (params.entity_type) queryParams.append('entity_type', params.entity_type);
    if (params.action) queryParams.append('action', params.action);
    if (params.date_from) queryParams.append('date_from', params.date_from);
    if (params.date_to) queryParams.append('date_to', params.date_to);
    if (params.limit) queryParams.append('limit', params.limit);
    const qs = queryParams.toString();
    return api.get(`/user-logs${qs ? `?${qs}` : ''}`);
};

export const getUserLog = (id) => api.get(`/user-logs/${id}`);
export const getUserLogsStats = () => api.get('/user-logs/stats');
